import { ComponentCtaButtonColor, TypeComponentCtaButton } from '../types'

export const patchCTAWithDefaultColor = (
  currentCta: TypeComponentCtaButton,
  newCtaEntry: TypeComponentCtaButton,
  defaultColor = ComponentCtaButtonColor.WhiteTextGreenButton
): TypeComponentCtaButton => {
  return {
    ...newCtaEntry,
    fields: {
      ...newCtaEntry.fields,
      color: currentCta.fields.color ?? defaultColor,
    },
  }
}
